import { render, staticRenderFns } from "./PerAchTrxTypeFeeReductionRewardEditor.vue?vue&type=template&id=0214fa7e&scoped=true"
import script from "./PerAchTrxTypeFeeReductionRewardEditor.vue?vue&type=script&lang=ts"
export * from "./PerAchTrxTypeFeeReductionRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214fa7e",
  null
  
)

export default component.exports